/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from 'react'
import { Link } from 'react-router-dom'
// import CheckPermission from '../Permissions/CheckPermission'
class ForConciergeSideNavBar extends React.Component {
  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <i className="icofont icofont-folder"></i>
                </span>
                <span className="pcoded-mtext">Concierge</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Cruise Booking</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/event-book">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Event Booking</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/concierge-kashta-book">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Kashta Booking</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/concierge-chalet">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Chalet Booking</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="">
              <Link to="/all-bookings/CRUISE">
                <span className="pcoded-micon">
                  <i className="icofont icofont-library"></i>
                </span>
                <span className="pcoded-mtext">Bookings</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default ForConciergeSideNavBar
